"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BleedingEffectHandler = exports.BleedingEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const core_1 = require("../../vfx/core");
const LocationSelector_1 = require("../../vfx/LocationSelector");
const core_2 = require("../../event-handlers/core");
const enums_1 = require("../../enums");
const Target_1 = require("../../Target");
const DelayedDamage_1 = require("../../DelayedDamage");
class BleedingEffectArgs {
    constructor(primaryAttribute, power) {
        this.primaryAttribute = primaryAttribute;
        this.power = power;
        this.__type = EffectType_1.EffectType.Bleeding;
        this.__typeName = "Bleeding";
        this.name = "Bleeding";
        this.harmful = true;
    }
}
exports.BleedingEffectArgs = BleedingEffectArgs;
let BleedingEffectHandler = class BleedingEffectHandler {
    apply(sequence, container, state) {
        if (container.hasEffectOfType(state.targetId, EffectType_1.EffectType.BleedImmunity)) {
            container.cancelEffect(sequence, state.id);
            return;
        }
        state.meta.eventHandlerId = container.registerEventHandler(state.targetId, state.duration.type === enums_1.DurationType.Ticks ? EventType_1.EventType.Tick
            : EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new core_2.RecurringDamageEventHandlerArgs(state.creatorId, Target_1.Target.Self, new DelayedDamage_1.DelayedDamage(state.args.__typeName, state.args.primaryAttribute, "Physical", state.args.power)));
        const bleedingVfx = new core_1.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(state.targetId, "feet"), "Bleeding");
        state.meta.vfxStepArgsId = bleedingVfx.id;
        sequence.push(bleedingVfx);
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
        sequence.push(new core_1.CancelAuraVfxStepArgs(state.meta.vfxStepArgsId));
    }
};
BleedingEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Bleeding)
], BleedingEffectHandler);
exports.BleedingEffectHandler = BleedingEffectHandler;
